import { defineMessages } from 'react-intl';

const messages = defineMessages({
  interface_name: '对接人',
  leader_name: '负责人',
  job_title: '职位',
  email: '邮箱',
  telephone: '电话',
});

export default messages;
